import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/lib/auth";

/**
 * Gate a route behind both auth and admin (`is_superuser`).
 *  - Not authenticated → /login (preserving the intended destination)
 *  - Authenticated but not admin → /projects (graceful, no scary 403 page)
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const token = useAuth((s) => s.token);
  const user = useAuth((s) => s.user);
  const location = useLocation();

  if (!token) return <Navigate to="/login" state={{ from: location }} replace />;
  if (!user?.is_superuser) return <Navigate to="/projects" replace />;
  return <>{children}</>;
}
